// import * as React from "react";
import { Box } from "@mui/material";
import IntroCourses from "../../components/courses/IntroCourses";
import Loopingpromo from "../../components/global/Loopingpromo";
import Courses from "../../components/courses/Courses";
import WhyIstqb from "../../components/courses/WhyIstqb";
import Testimonials from "../../components/global/Testimonials";
import TeamBanner from "../../components/global/TeamBanner";
import Lectors from "../../components/Lectors";
import Newsletter from "../../components/Newsletter";
import Footer from "../../components/global/Footer";
import Kompas from "../../components/courses/Kompas";
import Dontlosejob from "../../components/courses/Dontlosejob";
import Financing from "../../components/courses/Financing";
import Accredited from "../../components/courses/Accredited";
import financing from "../../data/financing";
import ScrollToTopButton from "../../components/global/ScrollToTop";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import FormKontaktGlobal from "../../components/global/FormKontaktGlobal";
import Loan from "../../components/courses/Loan";
import Header from "../../components/global/Header";
import ButtonFinancovanie from "../../components/global/ButtonFinancovanie";
import axios from "axios";
import {courses} from "../../data/courses";
import {usePromoPopUpHelper} from "../../components/global/promoPopUp/usePromoPopUpHelper";
import PromoPopUpV2 from "../../components/global/promoPopUp/PromoPopUpV2";
import ModalOverlay from "../../components/global/ModalOverlay";
import Vouchers from "../../components/vouchers/Vouchers";

const Skolenia = () => {
  // popup kontakt form
  const location = useLocation();
  const [openContactForm, setContactForm] = useState(false);
  const [contactMessage, setContactMessage] = useState("");
  const [lectorId, setLector] = useState("");
  const [fetchedData, setFetchedData] = useState([]);

    // promo pop-up handling
    const usePopUp = true; // true to activate popup
    const [showPromoPopUp, setShowPromoPopUp] = useState(false);
    const {handlePromoPopUp} = usePromoPopUpHelper();

  useEffect(() => {
    // Get the URL parameters
    const searchParams = new URLSearchParams(window.location.search);
    const lector = searchParams.get("lector");
    setLector(lector);
  }, []);

    const handleClick = (e) => {
        if (e.target.id === "bg") {
            setContactForm(false);
            setShowPromoPopUp(false);
        }
    }

  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.location.hash.substring(1)) {
        setTimeout(function () {
            const hash = window.location.hash.substring(1);
            const section = document.getElementById(hash);
            if (section) {
                section.scrollIntoView({ behavior: "smooth" });
            }
        }, 500);
    }
  }, [location.pathname]);

  // btn fin
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const threshold = 200; // Adjust this value as needed

      if (scrollPosition > threshold) {
        setShowContent(true);
      } else {
        setShowContent(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // width handling

  useEffect(() => {
      if (usePopUp) {
          handlePromoPopUp(setShowPromoPopUp);
      }

    // Update the window width when the component mounts
    setWindowWidth(window.innerWidth);

    // Add event listener to update the window width on resize
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // FETCHING DATA
  useEffect(() => {
    const fetchCourseData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}trainings?filter=with_valid_terms`);
        const data = response.data;
        setFetchedData(data.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchCourseData();
  }, []);

  function handleShowModalWindow() {
      if (openContactForm || (showPromoPopUp && windowWidth < 600)) {
          return (
              <ModalOverlay handleClick={handleClick}>
                  {renderModalWindow()}
              </ModalOverlay>
          );
      }
  }

    function renderModalWindow() {
        if (openContactForm) {
            return <FormKontaktGlobal setContactForm={setContactForm} contactMessage={contactMessage} />
        } else if (showPromoPopUp) {
            return <PromoPopUpV2 setShowPromoPopUp={setShowPromoPopUp} />
        } else return;
    }

  return (
    <Box>
      {showContent && windowWidth > 1100 && <ButtonFinancovanie isSkolenia={true} />}
      <Header />
      <IntroCourses windowWidth={windowWidth} />
      <Loopingpromo />
        <Courses
            courses={courses}
            setContactForm={setContactForm}
            setContactMessage={setContactMessage}
            fetchedData={fetchedData}
            windowWidth={windowWidth}
        />
        <Vouchers windowWidth={windowWidth} />
      <ScrollToTopButton />
      <WhyIstqb />
      <Testimonials />
      <Kompas setContactForm={setContactForm} setContactMessage={setContactMessage} />
      <Dontlosejob setContactForm={setContactForm} setContactMessage={setContactMessage} />
      <Financing finances={financing} setContactForm={setContactForm} setContactMessage={setContactMessage} />
      <Loan setContactForm={setContactForm} setContactMessage={setContactMessage} />
      {/* <Conditions /> */}
      <Accredited windowWidth={windowWidth} />
      <TeamBanner />
      <Box
        sx={{
          backgroundColor: "#1b144a",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Lectors itemsPerPage={1} lectorId={parseInt(lectorId)}></Lectors>
      </Box>
      {/* newsletter subscription */}
      <Newsletter />
      <Footer setContactForm={setContactForm} setContactMessage={setContactMessage} />
      {handleShowModalWindow()}
    </Box>
  );
};

export default Skolenia;
